<template>
  <modal name="cardDeckSharedConfirmationModal" height="auto" width="500px" :scrollable="true" @before-open="setData">
    <div class="modal-content">
      <div class="modal-header d-flex flex-column">
        <div class="w-100 text-center" style="position: relative">
          <inline-svg class="mb-2" src="/assets/img/icons/check-circle.svg"></inline-svg>
          <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                  @click="$modal.hide('cardDeckSharedConfirmationModal')"></button>
        </div>
        <h4 class="modal-title">Card Deck Shared</h4>
        <div class="modal-subtitle-gray text-center">Your Card Deck ‘{{ cardDeckTitle ? cardDeckTitle : '' }}’ has been shared with {{heroes}}</div>
      </div>
      <div class="d-flex flex-column gap-2 p-3 mt-2" >
        <div class="d-flex flex-row justify-content-between gap-2">
          <btn class="btn-outline-light btn-lg flex-1"
               @click="viewCardDeck">
            View Card Deck
          </btn>
          <btn class="btn-primary btn-lg flex-1"
               @click="redirectToAddCardDeck">
            Create another Card Deck
          </btn>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>

export default {
    name: "CardDeckSharedConfirmationModal",
    data() {
        return {
            loading: {
                data: false,
                save: false,
            },
            cardDeckTitle: '',
            heroes: [],
        };
    },
    methods: {
        setData(event) {
            this.cardDeckTitle = event.params.cardDeckTitle;
            this.heroes = event.params.heroes;
        },
        redirectToAddCardDeck() {
            if (this.$route.name === 'card.decks') {
                this.$modal.show('addCardModal')
            } else {
                this.$router.push({ name: 'card.decks', params: {openAddCardDeck: 'open'}})
            }
              this.$modal.hide('cardDeckSharedConfirmationModal');
              this.$modal.hide('assignCardDeckModal');
        },
        viewCardDeck() {
          this.$modal.show('viewCardsModal', {cardDeck: this.cardDeckTitle});
          this.$modal.hide('cardDeckSharedConfirmationModal');
          this.$modal.hide('assignCardDeckModal');
        }
    }
}
</script>

<style scoped>

</style>
